import script from "./StartSMSChatModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./StartSMSChatModal.vue?vue&type=script&setup=true&lang=ts"

import "./StartSMSChatModal.vue?vue&type=style&index=0&id=5dcab970&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5dcab970"]])

export default __exports__